module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/camera-2f3fab89454efafcf163e98b4edfeb64.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/camera.svg
// module id = wP86
// module chunks = 24